module.exports = __webpack_public_path__ + "img/57_currency.d6ec51bf.jpg";